import { useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../create/confirmationModal";
import { ReactComponent as SaveLater } from "../../../../assets/images/svg/saveLater.svg";
import { ReactComponent as Arrow } from "../../../../assets/images/svg/twoPartyContract/arrow-left.svg";
import createStyles from "../../create/milestoneFormNavButton/styles.module.scss";
import styles from "./ui.module.scss";

interface INavButtonsProps {
  onNext: () => void;
  onPrev?: () => void;
  /** Without it there is no "save and continue later" (editing a published transaction). */
  onSaveDraft?: () => void;
  disabled: boolean;
  /** Replaces "التالي", e.g. "حفظ التعديلات" on the last step of an edit. */
  nextLabel?: string;
}

/**
 * Next / Previous / "Save and continue later", as the design draws them (52px high, the dark
 * Next). Saving for later asks first, with the multi-party wizard's confirmation.
 */
const NavButtons = ({
  onNext,
  onPrev,
  onSaveDraft,
  disabled,
  nextLabel,
}: INavButtonsProps) => {
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <div className={styles.nav}>
      {onSaveDraft ? (
        <button
          type="button"
          className={styles.saveLaterButton}
          onClick={() => setConfirmOpen(true)}>
          {t("lbl_save_and_continue_later")}
        </button>
      ) : (
        <span />
      )}
      <div className={styles.navGroup}>
        {onPrev && (
          <button type="button" className={styles.prevButton} onClick={onPrev}>
            <Arrow className={styles.arrowPrev} />
            {t("lbl_prev")}
          </button>
        )}
        <button
          type="button"
          className={styles.nextButton}
          disabled={disabled}
          onClick={onNext}>
          {nextLabel || t("lbl_next_step")}
          {!nextLabel && <Arrow className={styles.arrowNext} />}
        </button>
      </div>
      <ConfirmationModal
        handleClose={() => setConfirmOpen(false)}
        handleConfirm={async () => {
          setConfirmOpen(false);
          await onSaveDraft?.();
        }}
        confirmText={t("lbl_save_as_draft")}
        cancelText={t("lbl_back")}
        modalOpen={confirmOpen}
        title={t("lbl_save_and_continue_later_title")}
        description={t("lbl_save_and_continue_later_desc")}
        icon={<SaveLater />}
        containerStyle={createStyles.modalContainer}
      />
    </div>
  );
};

export default NavButtons;
